import React from 'react';
import { ArrowDown } from 'lucide-react';
import { Reveal } from '../Reveal';
import { Eyebrow } from './SectionBand';
import { DeviceFrame } from './DeviceFrame';
const readerContext = ['Known reader interest', 'What matters to them', 'Where they are stuck', 'Actions they have taken', 'What kind of support may fit'];
const authorEnablement = ['Stronger sales conversations', 'Podcast talking points', 'Speaking and webinar assets', 'Workshop ideas', 'Follow-up assets', 'Content angles', 'Clearer offer paths'];
export function AuthorLeverage() {
  return <section className="bg-navy px-6 py-20 text-paper md:px-10 md:py-28" data-id="element-547" data-mp="939n4rbv9p9h">
      <div className="mx-auto max-w-6xl" data-id="element-548" data-mp="dyox386r710m">
        <div className="max-w-3xl" data-id="element-549" data-mp="izcymnslz093">
          <Reveal data-id="element-550" data-mp="j0e84ntz7eop">
            <Eyebrow data-id="element-551" data-mp="j0xqu6rga73s">Because of the reader path</Eyebrow>
            <h2 className="mt-4 font-serif text-3xl leading-[1.08] text-paper md:text-5xl" data-id="element-552" data-mp="1pfye7o2etgyr">
              The reader gets a useful path.
              <br data-id="element-553" data-mp="1ucyk9yz9ejpv" />
              <span className="italic text-seaglass-light" data-id="element-554" data-mp="1ugmgj5w39k8a">
                Because of that, the author gets more leverage.
              </span>
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-paper/70" data-id="element-555" data-mp="1e6w0g709zcgt">
              The reader path shows you what matters, where someone is stuck,
              what they have done, and what kind of help may fit.
              <br data-id="element-556" data-mp="147521u8lgdbg" />
              The same build also turns the book’s ideas into stronger speaking,
              content, follow-up, and sales assets.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid items-start gap-10 lg:grid-cols-[1.2fr_1fr] lg:gap-14" data-id="element-557" data-mp="ugagyt733jrl">
          <Reveal delay={0.1} data-id="element-558" data-mp="qh1nlpfyhnwk">
            <div className="rounded-3xl bg-white/[0.04] p-4 md:p-6" data-id="element-559" data-mp="qe5kznt5yb1s">
              <DeviceFrame variant="browser" src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/4wv71qfbbbwbngbvre9mbk/67ed1325-767e-4f35-bd1c-b49fa7a310ff/08_author_console_lead_detail.jpg" alt="Author console — reader activity becomes author-side context" url="app.bookactivation.com/leads" aspect="16 / 10" data-id="element-560" data-mp="liqczchu79da" />
              <p className="mt-4 text-center text-base font-medium text-paper/70" data-id="element-561" data-mp="1xq22vhn6dmk">
                Author console — reader activity becomes author-side context
              </p>
            </div>
          </Reveal>

          {/* Causal hierarchy: reader context (input) -> author enablement (outcome) */}
          <Reveal delay={0.15} data-id="element-562" data-mp="klv2bsz3bggm">
            <div data-id="element-563" data-mp="kllfge9cdpf5">
              <div className="rounded-2xl border border-white/12 bg-white/[0.04] p-6" data-id="element-564" data-mp="kn6ae4zkjadj">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-seaglass-light" data-id="element-565" data-mp="pjwmkh895lto">
                  Reader context
                </p>
                <div className="mt-3 flex flex-wrap gap-2" data-id="element-566" data-mp="fv4zoni1trpm">
                  {readerContext.map(item => <span key={item} className="rounded-lg border border-white/12 bg-navy-light/40 px-3 py-1.5 text-sm text-paper/85" data-id="element-567" data-mp="fss6tfar5wxs">
                      {item}
                    </span>)}
                </div>
              </div>

              <div className="flex flex-col items-center py-3" data-id="element-568" data-mp="2t1cnl236hlbq">
                <ArrowDown className="h-5 w-5 text-seaglass-light" data-id="element-569" data-mp="2szi3fpzqdx8p" />
                <span className="mt-1 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-paper/45" data-id="element-570" data-mp="2o28hwlfgq5q5">
                  which becomes
                </span>
              </div>

              <div className="rounded-2xl border-2 border-seaglass/50 bg-white/[0.06] p-6 shadow-[0_24px_50px_-30px_rgba(0,0,0,0.6)]" data-id="element-571" data-mp="2xtmccesk4fcf">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-sand" data-id="element-572" data-mp="2a534g0df64kv">
                  Author enablement
                </p>
                <div className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-573" data-mp="2k1g73nqxzsrr">
                  {authorEnablement.map(item => <div key={item} className="flex items-start gap-2.5 text-paper/90" data-id="element-574" data-mp="2f11wpz1vc6qk">
                      <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-sand" data-id="element-575" data-mp="3vfk0ostmbewa" />
                      <span className="leading-snug" data-id="element-576" data-mp="3qhrxv3rfq8db">{item}</span>
                    </div>)}
                </div>
              </div>
            </div>
          </Reveal>
        </div>

        <p className="mx-auto mt-12 max-w-2xl text-center text-base text-paper/55" data-id="element-577" data-mp="24z7w4ze8jplv">
          Prototype shown to demonstrate the reader and author experience. No
          performance outcomes are represented.
        </p>
      </div>
    </section>;
}